import Component from './component.jsx'
export default Component

export { Error as TextAreaWithCharacterCounterError } from './component.styles'
